<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/users`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование данных пользователя</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="lastName" class="form-label col-md-3">
          Фамилия
        </label>
        <div class="col-md-9">
          <input class="form-control" id="lastName" type="text" v-model="user.lastName">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="firstName" class="form-label col-md-3">
          Имя
        </label>
        <div class="col-md-9">
          <input class="form-control" id="firstName" type="text" v-model="user.firstName">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="patronymic" class="form-label col-md-3">
          Отчество
        </label>
        <div class="col-md-9">
          <input class="form-control" id="patronymic" type="text" v-model="user.patronymic">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="iin" class="form-label col-md-3">
          ИИН
        </label>
        <div class="col-md-9">
          <input class="form-control" id="iin" type="text" :maxlength="12" :minlength="12" v-model="user.iin">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="email" class="form-label col-md-3">
          email
        </label>
        <div class="col-md-9">
          <input class="form-control" id="email" type="email" v-model="user.email">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="role" class="form-label col-md-3">
          Роль
        </label>
        <div class="col-md-9">
          <select v-model="user.role" id="role"
                  class="form-select">
            <option v-for="role in roles" :key="role.id" :value="role.id" :title="role.description">
              {{ role.name }}
            </option>
          </select>
        </div>
        <div class="el-col-offset-6 col-md-9" style="font-size: 14px">
          <i>
            {{ getRoleDescription(user.role) }}
          </i>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="positionTitle" class="form-label col-md-3">
          Должность
        </label>
        <div class="col-md-9">
          <input class="form-control" id="positionTitle" type="text" v-model="user.positionTitle">
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="university" class="form-label col-md-3">
          ВУЗ
        </label>
        <div class="col-md-9">
          <multiselect
              v-model="universityModel"
              :options="universities"
              :searchable="true"
              :closeOnSelect="true"
              label="nameRu"
              track-by="universityId"
              :close-on-select="true"
              :allow-empty="true"
              placeholder="Выберите ВУЗ"
              :multiple="false"
              :clear-on-select="true"
          />
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="enabled" class="form-label col-md-3">
          Доступ к системе
        </label>
        <div class="col-md-9">
          <select v-model="user.enabled" id="enabled"
                  class="form-select">
            <option :value="null">Все</option>
            <option v-for="option in yesNoList" :key="option.id"
                    :value="option.id">
              {{ option.nameRu }}
            </option>
          </select>
        </div>
      </div>
    </div>

  </div>
  <div class="page-footer justify-content-end" v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import userService from "@/services/userService";
import universityService from "@/services/universityService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import {RoleEnum} from "@/enum/RoleEnum";
import delegationService from "@/services/delegationService";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  computed: {
    RoleEnum() {
      return RoleEnum
    },
    userId() {
      return this.$route.params.uuid;
    },
    universityModel: {
      get() {
        return this.universities.find(u => u.universityId === this.user.universityId) || null
      },
      set(val) {
        this.user.universityId = val && val.universityId ? val.universityId : null
      }
    }
  },
  data() {
    return {
      isLoading: false,
      user: {
        id: null,
        lastName: null,
        firstName: null,
        patronymic: null,
        iin: null,
        email: null,
        positionTitle: null,
        enabled: true
      },
      roles: [],
      universities: [],
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ]
    };
  },
  methods: {
    init() {
      if (this.userId === '0') {
      } else {
        this.findById(this.userId);
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    initRoles() {
      this.roles = [];

      for (const id in RoleEnum) {
        const role = {
          id: id,
          name: RoleEnum[id].name,
          description: RoleEnum[id].description,
        };
        this.roles.push(role);
      }
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
            this.universities.unshift({universityId: null, nameRu: "-- не выбрано --"});
          });
    },
    async findById(userId) {
      this.isLoading = true;
      this.user = await userService.findById(userId);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.user = await userService.save(this.user);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    getRoleDescription(value) {
      const role = RoleEnum[value];
      if (role) {
        return role.description;
      }
      return '';
    }
  },
  mounted() {
    this.init();
    this.initRoles();
    this.initUniversities();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
